import photo01 from '../assets/band_photos/band-photo-01.jpg';
import photo02 from '../assets/band_photos/band-photo-02.jpg';
import photo03 from '../assets/band_photos/band-photo-03.jpg';
import photo04 from '../assets/band_photos/band-photo-04.jpg';
import photo05 from '../assets/band_photos/band-photo-05.jpg';
import photo06 from '../assets/band_photos/band-photo-06.jpg';
import photo07 from '../assets/band_photos/band-photo-07.jpg';
import photo08 from '../assets/band_photos/band-photo-08.jpg';
import photo09 from '../assets/band_photos/band-photo-09.jpg';
import photo10 from '../assets/band_photos/band-photo-10.jpg';

const bandPhotos = [
  { src: photo01, alt: 'Malpractice Band performing under red and blue stage lights' },
  { src: photo02, alt: 'Two Malpractice musicians performing together on stage' },
  { src: photo03, alt: 'Malpractice vocalist singing into a microphone' },
  { src: photo04, alt: 'Malpractice bassist performing in red stage light' },
  { src: photo05, alt: 'Malpractice guitarist playing a white electric guitar' },
  { src: photo06, alt: 'Malpractice vocalist engaging the crowd during a live set' },
  { src: photo07, alt: 'Malpractice Band gathered on a red-lit stage' },
  { src: photo08, alt: 'Malpractice vocalists performing together' },
  { src: photo09, alt: 'Malpractice Band performing for a lively crowd' },
  { src: photo10, alt: 'Malpractice drummer and keyboard player during a live set' },
];

export default bandPhotos;
